import { myMeetingsIcon, toClassicIcon } from "common/defaultIcons";
import type { AppRouteRecordRaw } from "shared/types";
import {
  LAYOUTS,
  MODULE_SETTINGS,
  TEACHER_ROLES,
  USER_ROLES,
} from "shared/constants";
import { MY_MEETINGS_ROUTE_NAMES } from "./routeNames";

// The "Mijn besprekingen" overview covers every meeting type, so it lives in
// meetings/shared rather than one of the type-specific sub-domains. Same
// structure as the tasks overview: the parent redirects to the first tab,
// each tab is its own route.
const routes: AppRouteRecordRaw[] = [
  {
    path: "/my-meetings",
    name: MY_MEETINGS_ROUTE_NAMES.MY_MEETINGS,
    component: () => import("views/EmptyView.vue"),
    redirect: { name: MY_MEETINGS_ROUTE_NAMES.MY_MEETINGS_OPEN },
    meta: {
      title: "Besprekingen",
      layout: LAYOUTS.MAIN_NO_WRAPPER,
      roleRequired: TEACHER_ROLES,
      icon: toClassicIcon(myMeetingsIcon),
      isMenuItem: true,
      menuSection: "main",
      menuOrder: 3,
      settingRequired: [MODULE_SETTINGS.STUDENT_MEETING],
      hideTitle: true,
      exactRouteIdentifier: "myMeetings",
    },
    children: [
      {
        path: "open",
        name: MY_MEETINGS_ROUTE_NAMES.MY_MEETINGS_OPEN,
        component: () =>
          import("meetings/shared/pages/TeacherMyMeetingsPage.vue"),
        meta: {
          roleRequired: TEACHER_ROLES,
        },
      },
      {
        path: "completed",
        name: MY_MEETINGS_ROUTE_NAMES.MY_MEETINGS_COMPLETED,
        component: () =>
          import("meetings/shared/pages/TeacherMyMeetingsPage.vue"),
        meta: {
          roleRequired: TEACHER_ROLES,
        },
      },
      {
        // Legacy notification landing (list + highlight, pre-redesign). The
        // meeting type can't be derived from a bare id, so old links fall
        // back to the open tab; notifications now link to the typed detail
        // routes directly.
        path: ":meetingId",
        name: MY_MEETINGS_ROUTE_NAMES.MY_MEETINGS_MEETING_ID,
        redirect: { name: MY_MEETINGS_ROUTE_NAMES.MY_MEETINGS_OPEN },
      },
      {
        path: "shortage/:teacherShortage",
        name: MY_MEETINGS_ROUTE_NAMES.MY_MEETINGS_TEACHER_SHORTAGE,
        component: () =>
          import("meetings/shared/pages/TeacherMyMeetingsPage.vue"),
        meta: {
          roleRequired: [
            USER_ROLES.WEBMASTER,
            USER_ROLES.MANAGER,
            USER_ROLES.ORGANIZER,
            USER_ROLES.TEAMLEADER,
          ],
        },
        beforeEnter: (to, from, next) => {
          to.meta.title = `Besprekingen van ${to.params.teacherShortage}`;
          next();
        },
      },
    ],
  },
];

export default routes;
